import React from 'react'

function Loading() {
  return (
    <div className="loading">Loading&#8230;</div>
  )
}

export default Loading